import { BlacklistAutoRuleIdSchema as l } from "@hprofits/shared";
import { PrivilegeEnum as t } from "@hprofits/shared/auth";
import { z as u } from "zod";
import "../common/acl-view.js";
import { ocPrivate as e } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as i } from "../common/creation-result.js";
import "../common/owner.js";
import { BlacklistAutoRuleIdParamSchema as o } from "../common/params.js";
import "../common/errors/constants.js";
import { notFoundError as r, expectationFailedError as m } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { UpdateBlacklistAutoRuleSchema as c, CreateBlacklistAutoRuleSchema as n, BlacklistAutoRuleSchema as p, BlacklistAutoRuleListQuerySchema as d, BlacklistAutoRuleListSchema as S, BlacklistSspTargetsPreviewQuerySchema as A, BlacklistSspTargetsSchema as s, BlacklistSspTargetsQuerySchema as k } from "./schemas.js";
const v = {
  blacklistAutoRule: {
    sspTargets: e([t.ReadAdmin]).route({
      method: "GET",
      path: "/blacklist-auto-rules/ssp-targets",
      summary: "List saved blacklist rule SSP feed targets",
      tags: [a.BLACKLIST_AUTO_RULES.name]
    }).input(k).output(s).errors({}),
    /**
     * SSP feed targets of the rule editor's unsaved ad unit links. POST because the id lists of a
     * large rule outgrow a query string. Rows carry no `rules`: the draft has no saved rule yet.
     */
    sspTargetsPreview: e([t.ReadAdmin]).route({
      method: "POST",
      path: "/blacklist-auto-rules/ssp-targets/preview",
      summary: "List SSP feed targets of unsaved blacklist rule ad unit links",
      tags: [a.BLACKLIST_AUTO_RULES.name]
    }).input(A).output(s).errors({}),
    /**
     * List blacklist auto-rules.
     *
     * `adUnitIds` matches a rule whether the ad unit is a target of the rule or an exception from
     * its ad unit types — the same "mentions this ad unit" semantics the Go filter has.
     */
    findAll: e([t.ReadAdmin]).route({
      method: "GET",
      path: "/blacklist-auto-rules",
      summary: "List blacklist auto-rules",
      tags: [a.BLACKLIST_AUTO_RULES.name]
    }).input(d).output(S).errors({}),
    /**
     * Get a blacklist auto-rule by ID
     */
    findOne: e([t.ReadAdmin]).route({
      method: "GET",
      path: "/blacklist-auto-rules/{ruleId}",
      summary: "Get a blacklist auto-rule by ID",
      tags: [a.BLACKLIST_AUTO_RULES.name]
    }).input(o).output(p).errors({
      ...r("Blacklist auto-rule not found"),
      ...m("The stored condition or action cannot be read")
    }),
    /**
     * Create a blacklist auto-rule
     */
    create: e([t.WriteAdmin]).route({
      method: "POST",
      path: "/blacklist-auto-rules",
      summary: "Create a blacklist auto-rule",
      tags: [a.BLACKLIST_AUTO_RULES.name],
      successStatus: 201
    }).input(n).output(i(l)).errors({
      ...r("Ad unit, ad unit type or dictionary entity not found")
    }),
    /**
     * Update a blacklist auto-rule.
     *
     * Every link array is replaced wholesale, so the payload alone defines the stored combination.
     */
    update: e([t.WriteAdmin]).route({
      method: "PUT",
      path: "/blacklist-auto-rules/{ruleId}",
      summary: "Update a blacklist auto-rule",
      tags: [a.BLACKLIST_AUTO_RULES.name],
      successStatus: 204
    }).input(c).output(u.void()).errors({
      ...r("Blacklist auto-rule, ad unit or ad unit type not found")
    }),
    /**
     * Delete a blacklist auto-rule
     */
    remove: e([t.WriteAdmin]).route({
      method: "DELETE",
      path: "/blacklist-auto-rules/{ruleId}",
      summary: "Delete a blacklist auto-rule",
      tags: [a.BLACKLIST_AUTO_RULES.name],
      successStatus: 204
    }).input(o).output(u.void()).errors({
      ...r("Blacklist auto-rule not found")
    })
  }
};
export {
  v as blacklistAutoRuleContract
};
//# sourceMappingURL=contract.js.map
